import React from 'react';
import './index.scss';

// fixed pseudo-random layout so the stars don't reshuffle between renders
const rnd = (i: number, k: number) => { const x = Math.sin(i * 127.1 + k * 311.7) * 43758.5453; return x - Math.floor(x); };
const makeStars = (count: number, seed: number) => Array.from({ length: count }, (_, j) => {
  const i = j + seed * 1000;
  return {
    left: rnd(i, 1) * 100,
    top: rnd(i, 2) * 100,
    size: rnd(i, 3) < 0.28 ? 10 + rnd(i, 4) * 8 : 2 + rnd(i, 4) * 2.5,  // a few sparkles, mostly small points
    delay: rnd(i, 5) * 4,
    dur: 2.4 + rnd(i, 6) * 2.6,
  };
});

/* Absolutely positioned layer of twinkling stars; the parent must be position:relative */
const Twinkle: React.FC<{ count?: number; seed?: number }> = ({ count = 46, seed = 0 }) => {
  const stars = React.useMemo(() => makeStars(count, seed), [count, seed]);
  return (
    <div className='stars' aria-hidden='true'>
      {stars.map((st, i) => (
        <i key={i} className={st.size > 6 ? 'sp' : ''} style={{ left: `${st.left}%`, top: `${st.top}%`, width: st.size, height: st.size, animationDelay: `${st.delay}s`, animationDuration: `${st.dur}s` }} />
      ))}
    </div>
  );
};

export default Twinkle;
